export const Urls = {
    BACKEND: {
        ACTIVITY_LOG: {
            GET_RECORDS: (queryStringParams: string) => `/activity-logs${queryStringParams}`,
        },
        AUTH: {
            CREATE_AUTH_TOKEN: '/auth-token',
            VALIDATE_AUTH_TOKEN: '/validate-auth-token',
        },
        CASHBOX_CATEGORY: {
            GET_RECORDS: (queryStringParams: string) => `/cashbox-categories${queryStringParams}`,
            UPSERT: `/cashbox-category`,
        },
        CASHBOX_STATEMENT: {
            GET_RECORDS: (queryStringParams: string) => `/cashbox-statements${queryStringParams}`,
        },
        CHAT: {
            CHAT: '/chat',
        },
        COMPANY: {
            GET_BY_ID: (companyId: number) => `/company/${companyId}`,
            UPSERT: `/company`,
        },
        CUSTOMER: {
            GET_RECORDS: (queryStringParams: string) => `/customers${queryStringParams}`,
            CREATE: '/customer',
            GET_BY_ID: (id: number) => `/customer/${id}`,
            SEND_ACCOUNT_BALANCE: `/customer-account-balance-send`,
        },
        EXPENDITURE_RECORD: {
            GET_RECORDS: (queryStringParams: string) => `/expenditure-records${queryStringParams}`,
            CREATE: '/expenditure-record',
        },
        INCOME_RECORD: {
            GET_RECORDS: (queryStringParams: string) => `/income-records${queryStringParams}`,
            CREATE: '/income-record',
        },
        LOGIN: () => `/login`,
        PAYABLE_CONTRACT: {
            CREATE: '/payable-contract',
            GET_RECORDS: (queryStringParams: string) => `/payable-contracts${queryStringParams}`,
            GET_BY_ID: (id: number) => `/payable-contract/${id}`,
            UPDATE: '/payable-contract',
        },
        PAYABLE_CONTRACT_DEBIT: {
            GET_RECORDS: (queryStringParams: string) => `/payable-contract-debits${queryStringParams}`,
            GET_BY_ID: (id: number) => `/payable-contract-debit/${id}`,
            DELETE: '/payable-contract-debit',
        },
        PAYABLE_CONTRACT_DEBIT_PAYMENT: {
            CREATE: '/payable-contract-debit-payment',
            GET_RECORDS: (queryStringParams: string) => `/payable-contract-debit-payments${queryStringParams}`,
        },
        QUOTATION: {
            UPSERT: '/quotation',
            GET_RECORDS: (queryStringParams: string) => `/quotations${queryStringParams}`,
            GET_BY_ID: (id: number) => `/quotation/${id}`,
            PDF: (id: number) => `/quotation/${id}/pdf`,
            SEND_TELEGRAM: (id: number) => `/quotation/${id}/send-telegram`,
            STATUS: (id: number) => `/quotation/${id}/status`,
            GET_TEMPLATES: (activeOnly: boolean = true) => `/quotation-templates?activeOnly=${activeOnly}`,
            UPSERT_TEMPLATE: '/quotation-template',
        },
        REPORT: {
            DASHBOARD_DATA: (dateFrom: string, dateTo: string) => `/dashboard?dateFrom=${dateFrom}&dateTo=${dateTo}`,
        },
        SERVICE: {
            GET_RECORDS: () => '/services',
            CREATE: '/service',
            GET_BY_ID: (id: number) => `/service/${id}`,
        },
        SERVICE_CATEGORY: {
            GET_RECORDS: () => '/service-categories',
            CREATE: '/service-category',
        },
        SERVICE_CONTRACT: {
            CREATE: '/service-contract',
            GET_RECORDS: (queryStringParams: string) => `/service-contracts${queryStringParams}`,
            GET_BY_ID: (id: number) => `/service-contract/${id}`,
            UPDATE: '/service-contract',
        },
        SERVICE_CONTRACT_DEBIT: {
            GET_RECORDS: (queryStringParams: string) => `/service-contract-debits${queryStringParams}`,
            GET_BY_ID: (id: number) => `/service-contract-debit/${id}`,
            DELETE: '/service-contract-debit',
        },
        SERVICE_CONTRACT_DEBIT_PAYMENT: {
            CREATE: '/service-contract-debit-payment',
            GET_RECORDS: (queryStringParams: string) => `/service-contract-debit-payments${queryStringParams}`,
            SEND_PAYMENT_RECEIPT: '/service-contract-debit-payment-send-receipt',
        },
        USER: {
            GET_RECORDS: () => '/users',
            UPSERT: '/user',
            GET_BY_ID: (id: number) => `/user/${id}`,
            UPDATE_PASSWORD: '/user-password',
        },
        USER_ROLE: {
            GET_RECORDS: () => '/user-roles',
        },
        UTILS: {
            HTML_TO_PDF: '/html-to-pdf',
        }
    },
    FRONTEND: {
        CASHBOX_CATEGORY: {
            RECORDS: '/cashbox-categories',
        },
        CASHBOX_STATEMENT: {
            RECORDS: '/cashbox-statements',
        },
        CUSTOMER: {
            CUSTOMERS: '/customers',
            CREATE: '/customer',
            EDIT_PAGE: (customerId: number) => `/customer/${customerId}`,
            EDIT: '/customer/:id',
            PROFILE: `/customer-profile/:id`,
            PROFILE_PAGE: (customerId: number) => `/customer-profile/${customerId}`,
        },
        DASHBOARD: '/dashboard',
        EXPENDITURE_RECORD: {
            RECORDS: '/expenditure-records',
            CREATE: '/expenditure-record',
        },
        INCOME_RECORD: {
            CREATE: '/income-record',
            RECORDS: '/income-records',
        },
        HOME: '/',
        CHAT: '/chat',
        LOGIN: '/login',
        LOGOUT: '/logout',
        SERVICE: {
            SERVICES: '/services',
            CREATE: '/service',
            EDIT: '/service/:id',
            EDIT_PAGE: (productId: number) => `/service/${productId}`,
        },
        SERVICE_CATEGORY: {
            SERVICE_CATEGORIES: '/service-categories',
        },
        SERVICE_CONTRACT: {
            CREATE: '/service-contract',
            SERVICE_CONTRACTS: '/service-contracts',
            EDIT: '/service-contract/:id',
            EDIT_PAGE: (id: number) => `/service-contract/${id}`,
            DETAIL: '/service-contract-detail/:id',
            DETAIL_PAGE: (id: number) => `/service-contract-detail/${id}`,
        },
        ACCOUNT_PAYABLE: {
            CREATE: '/account-payable',
            PAYABLE_CONTRACTS: '/account-payables',
        },
        PAYABLE_CONTRACT: {
            EDIT: '/payable-contract/:id',
            EDIT_PAGE: (id: number) => `/payable-contract/${id}`,
            DETAIL: '/payable-contract-detail/:id',
            DETAIL_PAGE: (id: number) => `/payable-contract-detail/${id}`,
        },
        PAYABLE_CONTRACT_DEBIT: {
            PAYABLE_CONTRACT_DEBITS: '/payable-contract-debits',
        },
        PAYABLE_CONTRACT_DEBIT_PAYMENTS: {
            PAYABLE_CONTRACT_PAYMENTS: '/payable-contract-debit-payments',
        },
        SERVICE_CONTRACT_DEBIT: {
            SERVICE_CONTRAC_DEBITS: '/service-contract-debits',
        },
        SERVICE_CONTRACT_DEBIT_PAYMENTS: {
            SERVICE_CONTRAC_DEBITS: '/service-contract-debit-payments',
        },
        SETTINGS: '/settings',
        USER: {
            USERS: '/users',
            CREATE: '/user',
            EDIT_PAGE: (userId: number) => `/user/${userId}`,
            EDIT: '/user/:id',
        },
        QUOTATION: {
            CREATE: '/quotation',
            EDIT: '/quotation/:id',
            EDIT_PAGE: (quotationId: number) => `/quotation/${quotationId}`,
            RECORDS: '/quotation-records',
            TEMPLATES: '/quotation-templates',
        }
    },
}
